<template>
	<div class="c-content-search__wrapper">
		<DsIconButton
			:class="isOnHero ? 'c-content-search__button': 'c-content-search__icon'"
			@click="search"
			@keydown.enter="search"
			icon-name="search"
			variant="ghost-neutral"
			data-testid="search-button"/>
		<input
			id="content-search-field"
			v-model="searchPhrase"
			type="search"
			role="search"
			class="c-content-search__field"
			:placeholder="placeholder"
			autocomplete="off"
			@keydown.enter="search"
		/>
	</div>
</template>

<script>
import { globalSearchEvents } from '../../settings/constants';
import { mapGetters, mapMutations } from 'vuex';
import { DsIconButton } from '@coloplast/design-system';

export default {
    name: 'content-search-field',
    props: ['placeholder', 'isOnHero'],
    emits: [globalSearchEvents.SEARCH],
    computed: {
        ...mapGetters({
            getContentSearchPhrase: 'getContentSearchPhrase',
        }),
        searchPhrase: {
            get() {
                return this.getContentSearchPhrase;
            },
            set(value) {
                //if reset
                if (!value.length && this.searchPhrase.length > 0) {
                    this.$emit(globalSearchEvents.SEARCH);
                }
                this.setContentSearchPhrase(value);
            },
        },
    },
    methods: {
        ...mapMutations(['setContentSearchPhrase']),
        search() {
            this.$emit(globalSearchEvents.SEARCH);
        },
    },
    components: { DsIconButton }
};
</script>
